"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var PALETTE_PRIMARY_MAIN = '#454952';
var PALETTE_ERROR_MAIN = '#B32032';
var PALETTE_DISABLED_DROPDOWN = 'rgba(0, 0, 0, 0.38)';
var FONT_REGULAR = ['benton-sans', 'sans-serif'].join(', ');
var FONT_CONDENSED = ['benton-sans-condensed', 'sans-serif'].join(', ');
var FONT_WEIGHT_REGULAR = '500';
var FONT_WEIGHT_MEDIUM = '600';
var FONT_WEIGHT_BOLD = '700';
/**
 * When consolidating with the Typography design,
 * "Regular" is font weight 500.
 * "Medium" is font weight 600.
 * "Bold" is font weight 700.
 * The "italic" font style can be used.
 * In the event that italics will never be used,
 * we can remove it from the Adobe project for greater speed.
 *
 * Note: be careful editing this object!
 * If any key names match a variant name,
 * the class will automatically be applied
 * when the variant is set to that key name.
 */

var TYPOGRAPHY = {
  h1: {
    fontFamily: FONT_CONDENSED,
    fontWeight: FONT_WEIGHT_BOLD,
    fontSize: 40,
    lineHeight: '46px'
  },
  h2: {
    fontFamily: FONT_CONDENSED,
    fontWeight: FONT_WEIGHT_REGULAR,
    fontSize: 40,
    lineHeight: '46px'
  },
  h3: {
    fontFamily: FONT_CONDENSED,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 28,
    lineHeight: '34px'
  },
  h4: {
    fontFamily: FONT_CONDENSED,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 19,
    lineHeight: '24px'
  },
  h5: {
    fontFamily: FONT_CONDENSED,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 16,
    lineHeight: '22px'
  },
  h6: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 16,
    lineHeight: '23px'
  },
  subtitle1: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 14,
    lineHeight: '24px'
  },
  subtitle2: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 13,
    lineHeight: '20px'
  },
  body1: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_REGULAR,
    fontSize: 14,
    lineHeight: '24px'
  },
  body2: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_REGULAR,
    fontSize: 12,
    lineHeight: '20px'
  },
  button: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_BOLD,
    fontSize: 13,
    lineHeight: '18px',
    textTransform: 'none'
  },
  button2: {
    fontFamily: FONT_CONDENSED,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 16,
    lineHeight: '18px',
    textTransform: 'uppercase'
  },
  caption: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 12,
    lineHeight: '17px',
    textTransform: 'uppercase'
  },
  overline: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 11,
    lineHeight: '16px',
    textTransform: 'uppercase'
  },
  error: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_REGULAR,
    fontSize: 12,
    lineHeight: '24px',
    color: PALETTE_ERROR_MAIN,
    textTransform: 'none'
  },
  textField: {
    fontSize: 14,
    lineHeight: '20px'
  },
  dialogHeader: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: 18,
    lineHeight: '26px'
  },
  dialogContent: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_REGULAR,
    fontSize: 14,
    lineHeight: '24px'
  },
  drawerTitle: {
    fontFamily: FONT_REGULAR,
    fontWeight: FONT_WEIGHT_REGULAR,
    fontSize: 13,
    lineHeight: '18px'
  },
  dropdown: {
    '&.squared': {
      fontFamily: FONT_REGULAR,
      fontWeight: FONT_WEIGHT_REGULAR,
      fontSize: 14,
      lineHeight: '20px'
    },
    '&.rounded': {
      fontFamily: FONT_REGULAR,
      fontWeight: FONT_WEIGHT_REGULAR,
      fontSize: 13,
      lineHeight: '18px'
    },
    '&.disabled': {
      color: PALETTE_DISABLED_DROPDOWN
    }
  },
  dateDisplay: {
    '&.top': {
      fontFamily: FONT_REGULAR,
      fontWeight: FONT_WEIGHT_REGULAR,
      fontSize: 12,
      lineHeight: '17px',
      textTransform: 'uppercase'
    },
    '&.bottom': {
      fontFamily: FONT_CONDENSED,
      fontWeight: FONT_WEIGHT_REGULAR,
      fontSize: 16,
      lineHeight: '23px'
    }
  }
};
var defaultTheme = {
  palette: {
    primary: {
      // Active tab, default text color, primary button color
      main: PALETTE_PRIMARY_MAIN,
      // Tab hovered over or selected, dark header
      dark: '#393C44',
      // Icon default state gray
      icon: '#B5BACE',
      // Disabled text field fill
      disabled: '#F2F5F7',
      // Dark Avatar background color
      avatar: '#9A9EAD'
    },
    secondary: {
      // Inactive tab gray
      main: '#929BB2',
      // Inactive nav icon gray
      navIcon: '#7C8292',
      // Tab border
      tabBorder: '#e8e8e8',
      // Disabled dropdown components
      disabledDropdown: PALETTE_DISABLED_DROPDOWN,
      // Button border
      buttonBorder: 'rgba(69, 73, 82, 0.5)'
    },
    error: {
      // Error text, error boxes, error fields
      main: PALETTE_ERROR_MAIN,
      // Unpaid indicator, badges, icons
      unpaid: '#FF3049',
      // Mild alerts, discounts
      highlight: '#FEFFED'
    },
    text: {
      primary: PALETTE_PRIMARY_MAIN
    }
  },
  typography: (0, _objectSpread2.default)({
    useNextVariants: true
  }, TYPOGRAPHY.body2, TYPOGRAPHY)
};

var ThemeProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ThemeProvider, _React$PureComponent);

  function ThemeProvider() {
    (0, _classCallCheck2.default)(this, ThemeProvider);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ThemeProvider).apply(this, arguments));
  }

  (0, _createClass2.default)(ThemeProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          children = _this$props.children;
      return React.createElement(_styles.MuiThemeProvider, {
        theme: (0, _styles.createMuiTheme)(theme)
      }, children);
    }
  }]);
  return ThemeProvider;
}(React.PureComponent);

ThemeProvider.defaultProps = {
  children: null,
  theme: defaultTheme
};
ThemeProvider.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object
};
var _default = ThemeProvider;
exports.default = _default;